"use client";

import { ReactNode } from "react";
import { Button } from "./Button";
import { Dialog } from "./Dialog";

const confirmDialogVariants = {
  confirm: {
    icon: "iconoir-check",
    iconColor: "green",
    confirmButtonVariant: "primary",
  },
  warning: {
    icon: "iconoir-warning-triangle",
    iconColor: "yellow",
    confirmButtonVariant: "primary",
  },
  delete: {
    icon: "iconoir-xmark",
    iconColor: "red",
    confirmButtonVariant: "danger",
  },
} as const;

interface ConfirmDialogProps {
  variant: keyof typeof confirmDialogVariants; // 'confirm' | 'warning' | 'delete' — REQUIRED
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  loading?: boolean; // Yes button spinner; disables both buttons
  children?: ReactNode; // optional content between title and buttons
}

const ConfirmDialog = ({
  variant: variantName,
  isOpen,
  onClose,
  onConfirm,
  title,
  loading,
  children,
}: ConfirmDialogProps) => {
  const variant = confirmDialogVariants[variantName];
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={variant.icon}
      iconColor={variant.iconColor}
    >
      {children}
      <div className="mt-6 flex gap-3 justify-end">
        <Button
          type="button"
          variant="outline"
          disabled={loading}
          onClick={onClose}
        >
          No
        </Button>
        <Button
          type="button"
          variant={variant.confirmButtonVariant}
          loading={loading}
          disabled={loading}
          onClick={onConfirm}
        >
          Yes
        </Button>
      </div>
    </Dialog>
  );
};

export { ConfirmDialog, type ConfirmDialogProps };
